import {SearchPageType} from '../../../search-config';
import {
    getDocumentPreviewApiUrl,
    getHighlightApiUrl,
    getRelativePreviewLink
} from '../../../../services/search-service';
import {AbortCategory, fetchPdf, fetchWithBody, postJsonWithBody} from '../../../../services/fetcher';
import {HibuDocumentPreviewResponse, HibuHighlightResponse} from '../../../../common/pdf-viewer/PdfViewer.types';
import {PreviewDocument} from './docPreviewRow-types';
import {Buffer} from 'buffer';
import {SpotlightTagType} from '../../../../config/config-types';
import {HibuHitDoc} from '../../../search-types';
import {getCurrentLanguage} from '../../../../i18n-service';

export async function fetchPlainDocument(searchPageType: SearchPageType, documentId: string, containerName: string): Promise<HibuHitDoc | undefined> {
    const previewRequest = {
        container: containerName,
        displayLanguage: getCurrentLanguage(),
        documentId: documentId
    };
    try {
        const response = await postJsonWithBody<HibuDocumentPreviewResponse | undefined>(
            getDocumentPreviewApiUrl(searchPageType),
            JSON.stringify(previewRequest),
            AbortCategory.DETAILS);

        return response?.doc;

    } catch (error) {
        console.log(error);
        return undefined;
    }
}

export async function fetchPdfDocument(searchPageType: SearchPageType, previewLink: string): Promise<PreviewDocument | undefined> {
    const link = getRelativePreviewLink(searchPageType, previewLink);
    try {
        const response = await fetchPdf(link, AbortCategory.PREVIEW);
        if (response) {
            return {
                documentBlob: response
            };
        }
        return undefined;
    } catch (error) {
        console.log(error);
        return undefined;
    }
}

function base64ToBlobData(str: string) {
    const fileDataProcessed = Buffer.from(str, 'base64').toString('binary');
    return Buffer.from(fileDataProcessed, 'base64');
}

export async function fetchHighlightedDocument(
    type: SearchPageType,
    docId: string,
    query: string,
    containerName: string,
    highlightTags: boolean,
    spotlightTagTypes: SpotlightTagType[],
    previewPath?: string): Promise<PreviewDocument | undefined> {
    const location = getHighlightApiUrl(type);
    const language = getCurrentLanguage();
    const hlRequest = {
        container: containerName,
        documentId: docId,
        relativeFilePath: previewPath,
        query: query,
        language: language,
        fields: ['content', 'title'],
        highlightTags: highlightTags,
        highlightTagTypes: spotlightTagTypes.map(h => h.name)
    };
    return fetchWithBody<HibuHighlightResponse | undefined>(
        location,
        'POST',
        JSON.stringify(hlRequest),
        AbortCategory.PREVIEW
    )
        .then((data?: HibuHighlightResponse) => {
            if (!data) {
                return; // Fetch was aborted.
            }
            if (data.fileBytes !== undefined) {
                const decodedPdf = base64ToBlobData(data.fileBytes);
                const blob = new Blob([decodedPdf], {type: 'application/pdf'});
                return {
                    documentBlob: blob,
                    title: data.textWithHighlights?.title,
                    content: data.textWithHighlights?.content
                };
            } else {
                return {
                    title: data.textWithHighlights?.title,
                    content: data.textWithHighlights?.content
                };
            }
        })
        .catch((error) => {
            console.log(error);
            return undefined;
        });
}
